export function ClubPointsInfoCard({ onOpenGuide }: { onOpenGuide?: () => void }) {
  return (
    <div className="rounded-xl border border-gold/40 bg-gold/5 p-3.5">
      <div className="text-sm font-bold text-navy">🏆 Bag Tag Club Points</div>
      <p className="mt-1.5 text-xs leading-relaxed text-ink-soft">
        Club points are awarded automatically after every round based on achievements such as birdies,
        eagles, match wins, and participation.
      </p>
      <p className="mt-1 text-[11px] font-semibold text-mute">
        Game settings do not affect club points.
      </p>
      {onOpenGuide && (
        <button
          type="button"
          onClick={onOpenGuide}
          className="mt-2 text-xs font-bold text-gold-deep underline"
        >
          View full scoring guide →
        </button>
      )}
    </div>
  );
}
